export function normalizeBatches(rawBatches = []) {
  const uniqueBatches = new Map();

  (rawBatches || []).forEach((batch) => {
    if (!batch || !batch.upload_batch_id) return;
    if (!uniqueBatches.has(batch.upload_batch_id)) {
      uniqueBatches.set(batch.upload_batch_id, batch);
      return;
    }

    const existing = uniqueBatches.get(batch.upload_batch_id);
    const existingCount = Number(existing?.device_count || 0);
    const nextCount = Number(batch?.device_count || 0);
    if (nextCount > existingCount) {
      uniqueBatches.set(batch.upload_batch_id, batch);
    }
  });

  const normalized = Array.from(uniqueBatches.values()).sort((a, b) => {
    const numA = Number(a.upload_batch_number || 0);
    const numB = Number(b.upload_batch_number || 0);
    if (numA !== numB) return numB - numA;

    const dateA = a.uploaded_at ? new Date(a.uploaded_at).getTime() : 0;
    const dateB = b.uploaded_at ? new Date(b.uploaded_at).getTime() : 0;
    return dateB - dateA;
  });

  return normalized;
}

export default normalizeBatches;
